import React from "react";
import ContLogo from '../assets/contaduria_logo_color.png'

const logos = [
  {
    src: ContLogo,
    alt: "Cliente 1",
    url: "https://zamintech.com/portafolio/odin/build/",

  },
 /*  {
    src: "/logos/cliente2.png",
    alt: "Cliente 2",
  },
  {
    src: "/logos/cliente3.png",
    alt: "Cliente 3",
  },
  {
    src: "/logos/cliente4.png",
    alt: "Cliente 4",
  }, */
];

const Partners = () => {
  return (
    <section className="py-16 px-6 bg-gray-50" id="marcas">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-10">
        Nuestros Clientes
      </h2>
      <div className="flex flex-wrap justify-center items-center gap-10 max-w-5xl mx-auto">
        {logos.map((logo, index) => (
          <a key={index} href={logo.url} target="_blank" rel="noopener noreferrer">
            <img
              key={index}
              src={logo.src}
              alt={logo.alt}
              className="h-16 object-contain grayscale hover:grayscale-0 transition"
            />
          </a>
        ))}
      </div>
    </section>
  );
};

export default Partners;
